<template>
  <el-popover
    class="juree-auto-prefill-popover"
    :value="visibility"
    placement="bottom-end"
    width="340"
    trigger="manual"
  >
    <div class="content">
      <p>
        Are you submitting this film for <el-button
          type="text"
        ><a
          :href="matchingJureeEvent.link"
          target="_blank"
        >{{ matchingJureeEvent.title }}</a></el-button>?
      </p>
    </div>
    <div class="actions">
      <el-button
        @click="updateReferral(matchingJureeEvent.code)"
        icon="el-icon-check"
        type="text"
      >Yes</el-button>
      <el-button
        @click="updateReferral('')"
        icon="el-icon-close"
        type="text"
      >No</el-button>
    </div>

  </el-popover>
</template>

<script>
import jureeInfoProcessor from './jureeInfoProcessor';

export default {
  props: {
    submission: {
      type: Object,
      required: true,
    },
  },
  data() {
    jureeInfoProcessor.getFilteredEvent()
      .then((jureeDetails) => {
        this.$set(this, 'jureeDetails', jureeDetails);
      });

    return {
      jureeDetails: {
        map: {},
        keys: [],
      },
    };
  },
  computed: {
    // Is visible only when:
    // There is a matching country and referall is not touched (i.e. it is still server default value: undefined)
    visibility() {
      return !!this.matchingJureeCountry && !this.hasReferralCode;
    },

    hasReferralCode() {
      return this.submission.referral != null;
    },

    matchingJureeCountry() {
      if (!this.jureeDetails.keys.length) return false;

      const coutries = {
        entered: this.submission.country.split(',').map(s => s.toLowerCase()),
        expected: this.jureeDetails.keys,
      };
      return coutries.entered.find(enteredCountry => coutries.expected.some(expectedCountry => enteredCountry === expectedCountry));
    },
    matchingJureeEvent() {
      if (!this.matchingJureeCountry) return {};
      return jureeInfoProcessor.makeJureePackage(
        this.jureeDetails.map[this.matchingJureeCountry]
      );
    },
  },
  methods: {
    updateReferral(referral) {
      if (referral) {
        this.$notify.info({
          title: 'info',
          message: `${referral} has been added to referral field`,
        });
      }

      this.$emit('input', {
        referral,
      });
    },
  },
};
</script>

<style lang="scss">
.juree-auto-prefill-popover {
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;

  margin-top: -10px;
}
.juree-auto-prefill-popover {

  .content {
    button {
      padding: 0;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    button {
      padding-left: 10px;
      padding-right: 10px;
      color: initial;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/Shared/JureeAutoPrefillPopover/index.vue